import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import SignIn from "../views/Auth/SignIn.vue";
import HomeView from "@/views/HomeView.vue";
import DoctorsPage from "@/views/pages/DoctorsPage.vue";
import DoctorProfilePage from "@/views/pages/DoctorProfilePage.vue";
import FirstStepperView from "@/views/FirstStepperView.vue";
import OnboardingPage from "../components/SurveyStep.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "SignIn",
    component: SignIn,
    meta: { transition: "slide-down" },
  },
  {
    path: "/home",
    name: "HomeView",
    component: HomeView,
    meta: { transition: "slide-left" },
  },
  {
    path: "/firststepper",
    name: "FirstStepperView",
    component: FirstStepperView,
    meta: { transition: "slide-left" },
  },
  {
    path: "/onboarding",
    name: "OnboardingPage",
    component: OnboardingPage,
    meta: { transition: "slide-left" },
  },
  {
    path: "/register",
    name: "RegistrationPage",
    component: () => import("@/views/Auth/RegistrationPage.vue"),
    meta: { transition: "slide-up" },
    beforeEnter: async (to, from, next) => {
      await new Promise((resolve) => setTimeout(resolve, 50));
      next();
    },
  },
  {
    path: "/doctors",
    name: "DoctorsPage",
    component: DoctorsPage,
    meta: { transition: "slide-left" },
  },
  {
    path: "/doctors/:id",
    name: "DoctorProfilePage",
    component: DoctorProfilePage,
    meta: { transition: "slide-left" },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
